/* eslint-disable no-dupe-keys */
export default {
  eca_rule_outcome: {
    name: '优惠活动参与',
    // 属性（一般与对象内容匹配）
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      outcome_abstract: '来源摘要',
      eca_rule: '奖励',
      trigger: '活动优惠奖励',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询来源摘要'
    }
    // 详情页标签
  }
}
